/* eslint-disable consistent-return */
import { Grid } from '@material-ui/core';
import {
  getTrainingById,
  responseInvitationAffiliation,
} from '@webapps/business';
import {
  TextField,
  useMutation,
  useQuery,
  useToast,
  Button,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ModalFullScreen from 'components/ModalFullScreen/ModalFullScreen';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const Invite = ({ type, close, jobData, contractData, businessData, invitationId, school, classroom, refetch }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { addToast } = useToast();
  const [open, setOpen] = useState(false);
  const [labelAttachment, setLabelAttachment] = useState();
  const [path, setPath] = useState('');
  const [invitation, setInvitation] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const {
    error: errorInvitationAction,
    isLoading: isLoadingInvitationAction,
    isSuccess: isSuccessInvitationAction,
    mutate: mutateSetInvitationAction,
  } = useMutation(responseInvitationAffiliation);

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', classroom.training],
    variables: { id : classroom.training },
  });

  const responseInvit = async (id, action) => {
    await mutateSetInvitationAction({
      id,
      action,
    });
  };

  useEffect(() => {
    if (errorInvitationAction) {
      addToast({
        status: 'error',
        message: "Problème pour accepter l'invitation",
      });
    }
    if (isSuccessInvitationAction) {
      invitation === "ACCEPTED" ?
        addToast({
          status: 'success',
          message: 'Invitation acceptée',
        })
        :
        addToast({
          status: 'error',
          message: 'Invitation rejeté',
        })
      close();
      refetch();
    }
  }, [isSuccessInvitationAction, errorInvitationAction]);

  return (
    <div className={css({ marginTop: spacing(2) })}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label={type === "business" ? "Entreprise" : "Etablissement de formation"}
            value={type === "business" ? businessData?.name : school?.name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label={type === "business" ? "Intitulé du poste" : "Formation"}
            value={type === "business" ? jobData?.label : training?.label}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label="Lieu"
            value={type === "business" ?
              `${businessData?.address?.cityCode || 'Non renseigné'} ${businessData?.address?.city || ''}`
              :
              `${school?.address?.cityCode || 'Non renseigné'} ${school?.address?.city || ''}`
            }
          />
        </Grid>
        {type === "business" && (
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Contrat"
              value={contractData?.label}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(2),
          })}
          item
          xs
        >
          <Button
            className={css({
              borderRadius: '400px',
              marginRight: spacing(2),
            })}
            onClick={() => { responseInvit(invitationId, 'accept'); setInvitation("ACCEPTED") }}
            color="primary"
            variant="contained"
          >
            Accepter
          </Button>
          <Button
            className={css({
              borderRadius: '400px',
            })}
            color="secondary"
            variant="contained"
            onClick={() => { responseInvit(invitationId, 'reject'); setInvitation("REJECTED") }}
          >
            Décliner
          </Button>
        </Grid>
      </Grid>
      <ModalFullScreen
        onCancel={handleClose}
        open={open}
        title={labelAttachment}
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreen>
    </div>
  );
};

Invite.propTypes = {
  type: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  jobData: PropTypes.object,
  contractData: PropTypes.object,
  businessData: PropTypes.object,
  school: PropTypes.object,
  classroom: PropTypes.object,
  invitationId: PropTypes.string.isRequired,
  refetch: PropTypes.func
};

Invite.defaultProps = {
  jobData: {},
  contractData: {},
  businessData: {},
  school: {},
  classroom: {},
  invitationId: ''
};

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  return (
    <TextField disabled fullWidth label="Formation" value={training?.label} />
  );
};

Training.propTypes = {
  id: PropTypes.string,
};

export default Invite;